<template>
    <div class="website-container">
        <img src="../assets/logo.svg" alt="Das Logo der Weinprobe in den Weinbergen" class="logo">


        <div class="info-box">
            <h1>Die {{ weinprobenCounter }}. Weinprobe in den Grunbacher Weinbergen {{ year }}</h1>
            <h2>Samstag, {{ daySaturday }}.08.{{ year }} ab 16 Uhr</h2>
            <h2>Sonntag, {{ daySunday }}.08.{{ year }} ab 11 Uhr</h2>
        </div>

        <Countdown class="countdown" v-bind:deadline="'August ' + daySaturday + ', ' + year + ' 16:00'"></Countdown>
    </div>
</template>

<script>

import Countdown from '@/components/Countdown.vue'

export default {
    name: 'Greeting',
    props: {
        year: {
            type: String
        },
        daySaturday: {
            type: String
        },
        daySunday: {
            type: String
        },
        weinprobenCounter: {
            type: String
        }
    },
    components: { Countdown }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped  lang="scss">
    .logo {
        height: 10em;
    }

    @include lg {
        .logo {
            height: 15em;
        }
    }

    .countdown {
        background-color: rgba(255, 255, 255, 0.4);
        padding-bottom: 3em;
    }

    .info-box {
        padding: 1em;
        background-color: rgba(255, 255, 255, 0.4);
        -moz-box-shadow: 0 -10px 5px 5px rgba(255, 255, 255, 0.4);
        -webkit-box-shadow: 0 -10px 5px 5px rgba(255, 255, 255, 0.4);
        box-shadow: 0 -10px 5px 5px rgba(255, 255, 255, 0.4);        
    }

    .website-container {
        // width: 100%;
        // height: 100%;
        text-align: center;
        background: url(../assets/background.jpg) no-repeat center center fixed; 
        -webkit-background-size: cover;
        -moz-background-size: cover;
        -o-background-size: cover;
        background-size: cover;
    }
</style>
